import { gql } from '@apollo/client';

export const historiesGql = gql`
  query histories(
    $limit: Int! = 10
    $page: Int! = 1
    $consumer: String!
    $entityId: String!
    $entityType: String!
  ) {
    histories(
      limit: $limit
      page: $page
      consumer: $consumer
      entityId: $entityId
      entityType: $entityType
    ) {
      list {
        _id
        consumer
        tag
        criticity
        entity {
          _id
          type
        }
        doer {
          _id
          type
          firstName
          lastName
        }
        payload
        createdAt
        updatedAt
      }

      paging {
        current
        count
        limit
      }
    }
  }
`;
